import React from 'react';
import styles from '../../styles/countryadmissionsday.module.scss';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import CustomImage from "../CustomImage";
import Nav from 'react-bootstrap/Nav';
import Button from 'react-bootstrap/Button';
import router from 'next/router';
import useZipmeLink from '../../hooks/useZipmeLink';
import { isFrappeOrJotFormClass } from '../../utils/helpers';
interface Props {
  data: any;
  jotformId: string;
  externalLink:any;
}

const AdmissionDayHeader: React.FC<Props> = ({ data, jotformId, externalLink }) => {
  const { zipmeLink, generateLink } = useZipmeLink();
  

  return (
    <>
      <div
        className={styles.banner}
        style={{ backgroundColor: `${data?.sectionBorderBgColor}` }}
      >
        <Container>
          <div className={styles.nav}>
            <Row>
              <Col>
                <Nav>
                  <CustomImage
                      src={
                        data.kcImageUrl?.imageUrl ||
                        '/images/educationfair/kc_logo.svg'
                      }
                      width={180}
                      height={45}
                      className={styles.navLogo}
                      alt={data.kcImageUrl?.alt}
                    />
                </Nav>
              </Col>
            </Row>
          </div>
          <div className={styles.maincontent}>
            <Row>
              <div className='d-block d-sm-none text-center mb-4'>
                <Col xl={6} lg={6} md={12} xs={12}>
                  <div className={styles.bannerStudDiv}>
                    <div className={styles.bg}>
                      <CustomImage
                        src={
                          data.mainImageUrl?.imageUrl ||
                          '/images/admissionsday/university_logoImage.svg'
                        }
                        width={567}
                        height={427}
                        className={styles.cardImg}
                        layout='responsive'
                        alt={data.mainImageUrl?.alt}
                      />
                    </div>
                  </div>
                </Col>
              </div>
              <Col xl={6} lg={6} md={7} xs={12}>
                <div className={styles.fairdetails}>
                  <div className={styles.heading}>
                    <h1 style={{ color: data?.titleColor || '#fff' }}>
                      {data.titleLineOne} <br /> {data?.titleLineTwo}
                    </h1>
                    <p style={{ color: data?.subTitleColor || '#fff' }}>
                      {data.subTitle}
                    </p>
                    <ul className={styles.ulli}>
                      <li style={{ color: data?.pointsColor || '#fff' }}>
                        <CustomImage
                          src={data?.dateImageUrl}
                          width={26}
                          height={26}
                          alt='dateicon.png'
                        />
                        <div>{data.dateText}</div>
                      </li>
                      <li style={{ color: data?.pointsColor || '#fff' }}>
                        <CustomImage
                          src={data.timeImageUrl}
                          width={26}
                          height={26}
                          alt='timeicon'
                        />
                        <div>{data.timeText}</div>
                      </li>
                      {data.locationImageUrl && data?.locationText && (
                        <li style={{ color: data?.pointsColor || '#fff' }}>
                          <CustomImage
                            src={data.locationImageUrl}
                            width={26}
                            height={26}
                            alt='addressicon'
                          />
                          <div>{data.locationText}</div>
                        </li>
                      )}
                    </ul>
                  </div>
                  <div className={styles.regBtn}>
                    <Button onClick={() => {
                                        !jotformId && generateLink(externalLink);
                                   }}
                                className={`${styles.btnReg}${jotformId
                                    ? ` ${isFrappeOrJotFormClass(jotformId)}`
                                    : ''
                                    }`}
                            >
                                { data.button?.[0]?.label || 'Register Now' }
                            </Button>
                    <script
                      dangerouslySetInnerHTML={{
                        __html: `window.lintrk('track', { conversion_id: 6870956 });`,
                      }}
                    />
                  </div>
                </div>
              </Col>
              <Col xl={6} lg={6} md={5} xs={12}>
                <div className='d-none d-sm-block text-center mb-4'>
                  <div className={styles.bannerStudDiv}>
                    <div className={styles.bg}>
                      <CustomImage
                        src={
                          data.mainImageUrl?.imageUrl ||
                          '/images/admissionsday/university_logoImage.svg'
                        }
                        width={567}
                        height={427}
                        className={styles.cardImg}
                        layout='responsive'
                        alt={data.mainImageUrl?.alt}
                      />
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </>
  );
};
export default AdmissionDayHeader;
